import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { uploadFile } from './thunks'
import { UploadStateType } from './types'

const initialState: UploadStateType = {
  isLoading: false,
  isAttachmentLoading: false,
  error: null,
}

const upload = createSlice({
  name: 'upload',
  initialState,
  reducers: {
    setIsMediaLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setIsAttachmentLoading: (state, action: PayloadAction<boolean>) => {
      state.isAttachmentLoading = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(uploadFile.fulfilled, (state) => {
      state.isLoading = false
      state.isAttachmentLoading = false
    })
    builder.addCase(uploadFile.pending, (state) => {
      state.isLoading = true
      state.isAttachmentLoading = true
    })
    builder.addCase(uploadFile.rejected, (state, action) => {
      if (action.payload) {
        state.error = {
          message: action.payload.message,
        }
      }
      state.isLoading = false
      state.isAttachmentLoading = false
    })
  },
})

export const uploadReducer = upload.reducer
export const { setIsMediaLoading, setIsAttachmentLoading } = upload.actions
